import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
    HiOutlineHome,
    HiOutlineBriefcase,
    HiOutlineSearch,
    HiOutlineChatAlt2,
    HiOutlineCog,
    HiOutlineBell,
    HiPlus,
    HiOutlinePaperAirplane,
    HiOutlineEmojiHappy
} from "react-icons/hi";

// Mock Data
const mockChatsData = [
    { 
        id: 1, 
        name: "Elena Damyanti", 
        campaignName: "Summer Collection Launch",
        snippet: "Would you like to go...", 
        time: "4:52 PM", 
        unread: 5, 
        avatarColor: "bg-yellow-500", 
        isTyping: false,
        messages: [
            { id: 1, text: "Would you like to go to Meher's party with me?", time: "05:50PM", isBrand: true },
            { id: 2, text: "OK, sure! See you tonight.", time: "05:53PM", isBrand: false },
        ],
        statuses: [
            { id: 1, label: "Campaign Accepted", status: "completed", highlighted: true },
            { id: 2, label: "Content Created", status: "completed" },
            { id: 3, label: "Brand Review", status: "completed" },
            { id: 4, label: "Revisions", status: "completed" },
            { id: 5, label: "Content Approved", status: "completed", highlighted: true },
            { id: 6, label: "Campaign Completed", status: "completed", highlighted: true },
            { id: 7, label: "Payment Received", status: "current", highlighted: false }
        ]
    },
    { 
        id: 2, 
        name: "Alex Rivera", 
        campaignName: "Fitness Gear Promo",
        snippet: "Here is the draft video", 
        time: "1:30 PM", 
        read: true, 
        avatarColor: "bg-pink-500", 
        isTyping: false,
        messages: [
            { id: 1, text: "Hey Alex, any update on the content?", time: "10:00AM", isBrand: true },
            { id: 2, text: "Here is the draft video, please review it.", time: "1:30PM", isBrand: false },
        ],
        statuses: [
            { id: 1, label: "Campaign Accepted", status: "completed", highlighted: true },
            { id: 2, label: "Content Created", status: "current", highlighted: false },
            { id: 3, label: "Brand Review", status: "pending" },
            { id: 4, label: "Revisions", status: "pending" },
            { id: 5, label: "Content Approved", status: "pending", highlighted: false },
            { id: 6, label: "Campaign Completed", status: "pending", highlighted: false },
            { id: 7, label: "Payment Received", status: "pending", highlighted: false }
        ]
    },
    { 
        id: 3, 
        name: "Sarah Jenkins", 
        campaignName: "Winter Skincare",
        snippet: "Approved! Thanks.", 
        time: "Yesterday", 
        read: true, 
        avatarColor: "bg-blue-600", 
        isTyping: false,
        messages: [
            { id: 1, text: "I've uploaded the revised images.", time: "Yesterday, 3:00PM", isBrand: false },
            { id: 2, text: "Approved! Thanks.", time: "Yesterday, 4:00PM", isBrand: true },
        ],
        statuses: [
            { id: 1, label: "Campaign Accepted", status: "completed", highlighted: true },
            { id: 2, label: "Content Created", status: "completed" },
            { id: 3, label: "Brand Review", status: "completed" },
            { id: 4, label: "Revisions", status: "completed" },
            { id: 5, label: "Content Approved", status: "current", highlighted: true },
            { id: 6, label: "Campaign Completed", status: "pending", highlighted: false },
            { id: 7, label: "Payment Received", status: "pending", highlighted: false }
        ]
    },
    { 
        id: 4, 
        name: "Michael Chen", 
        campaignName: "Tech Gadget Review",
        snippet: "Typing...", 
        time: "Now", 
        unread: 1, 
        avatarColor: "bg-green-500", 
        isTyping: true,
        messages: [
            { id: 1, text: "Are we still on track for Friday?", time: "11:00AM", isBrand: true },
        ],
        statuses: [
            { id: 1, label: "Campaign Accepted", status: "completed", highlighted: true },
            { id: 2, label: "Content Created", status: "completed" },
            { id: 3, label: "Brand Review", status: "current" },
            { id: 4, label: "Revisions", status: "pending" },
            { id: 5, label: "Content Approved", status: "pending", highlighted: false },
            { id: 6, label: "Campaign Completed", status: "pending", highlighted: false },
            { id: 7, label: "Payment Received", status: "pending", highlighted: false }
        ]
    }
];

const BrandMessages = () => {
    const [messageInput, setMessageInput] = useState("");
    const [activeChatId, setActiveChatId] = useState(mockChatsData[0].id);

    const activeChat = mockChatsData.find(c => c.id === activeChatId) || mockChatsData[0];

    return (
        <div className="flex h-screen bg-[#FDFBF7]">
            {/* Sidebar */}
            <aside className="w-64 bg-white border-r border-gray-100 flex flex-col hidden md:flex shrink-0 z-20">
                <div className="p-6 flex items-center gap-2 text-black font-bold text-xl">
                    <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                    <span>Braccet</span>
                </div>

                <nav className="flex-1 px-4 py-6 space-y-2">
                    <NavItem to="/brand/dashboard" icon={<HiOutlineHome />} label="Overview" />
                    <NavItem to="/brand/campaigns" icon={<HiOutlineBriefcase />} label="Campaigns" />
                    <NavItem to="/brand/search" icon={<HiOutlineSearch />} label="Find Creators" />
                    <NavItem to="/brand/messages" icon={<HiOutlineChatAlt2 />} label="Messages" active />
                    <NavItem to="/brand/settings" icon={<HiOutlineCog />} label="Settings" />
                </nav>

                <div className="p-4 border-t border-gray-100">
                    <div className="flex items-center gap-3 p-2 rounded-xl hover:bg-gray-50 cursor-pointer">
                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold">
                            B
                        </div>
                        <div>
                            <p className="text-sm font-bold text-gray-900">Brand Name</p>
                            <p className="text-xs text-gray-500">brand@example.com</p>
                        </div>
                    </div>
                </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1 flex flex-col h-screen min-w-0 bg-[#FDFBF7]">
                
                {/* Top Header */}
                <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 px-6 py-3 flex justify-end items-center shrink-0 z-10 h-16">
                    <div className="flex items-center gap-4">
                        <div className="flex items-center gap-2">
                            <HiOutlineBell className="text-xl text-gray-600" />
                            <span className="text-sm font-bold">Johan Doe</span>
                        </div>
                        <div className="w-8 h-8 bg-[#0044CC] rounded-full"></div>
                    </div>
                </header>

                {/* Inner Messaging Container */}
                <div className="flex-1 p-6 overflow-hidden flex flex-col min-h-0">
                    <div className="flex-1 bg-white rounded-3xl shadow-sm border border-gray-100 flex overflow-hidden min-h-0">
                        
                        {/* LEFT COLUMN: Chat List */}
                        <div className="w-80 border-r border-gray-100 flex flex-col bg-white shrink-0">
                            <div className="p-6 pb-4 border-b border-gray-50 shrink-0">
                                <h2 className="text-xl font-bold text-gray-900 mb-6">Chat</h2>
                                <div className="relative">
                                    <input 
                                        type="text" 
                                        placeholder="Search" 
                                        className="w-full bg-gray-50 text-gray-700 text-sm rounded-xl py-3 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                    />
                                    <HiOutlineSearch className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
                                </div>
                            </div>
                            
                            <div className="flex-1 overflow-y-auto custom-scrollbar">
                                {mockChatsData.map((chat) => (
                                    <div 
                                        key={chat.id} 
                                        onClick={() => setActiveChatId(chat.id)}
                                        className={`flex items-start gap-3 p-4 cursor-pointer transition-colors border-b border-gray-50
                                            ${activeChatId === chat.id ? 'bg-blue-50/50' : 'hover:bg-gray-50'}
                                        `}
                                    >
                                        <div className={`w-10 h-10 rounded-full ${chat.avatarColor} shrink-0`}></div>
                                        <div className="flex-1 min-w-0">
                                            <div className="flex justify-between items-center mb-1">
                                                <h4 className="font-bold text-gray-900 text-sm">{chat.name}</h4>
                                                <span className="text-xs text-gray-400">{chat.time}</span>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <p className="text-sm text-blue-500 font-medium">{chat.snippet}</p>
                                                {chat.unread && (
                                                    <span className="w-5 h-5 bg-[#0044CC] text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                                                        {chat.unread}
                                                    </span>
                                                )}
                                                {chat.read && (
                                                    <div className="flex text-blue-500 text-sm">
                                                        <i className="fa-solid fa-check-double text-[10px]"></i>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* CENTER COLUMN: Chat Thread */}
                        <div className="flex-1 flex flex-col bg-[#FDFDFD] min-w-0">
                            {/* Thread Header */}
                            <div className="px-6 py-4 border-b border-gray-100 bg-white flex items-center gap-4 shrink-0 h-20">
                                <div className="w-10 h-10 bg-[#0044CC] rounded-full flex items-center justify-center shrink-0">
                                    <i className="fa-solid fa-cat text-white"></i> {/* Placeholder logic for Puma logo */}
                                </div>
                                <div>
                                    <h3 className="font-bold text-gray-900 text-sm">{activeChat.name}</h3>
                                    <p className="text-blue-500 text-xs font-medium">{activeChat.campaignName}</p>
                                </div>
                            </div>

                            {/* Messages Scroll Area */}
                            <div className="flex-1 overflow-y-auto p-6 space-y-6 custom-scrollbar bg-gray-50/50">
                                {activeChat.messages.map((msg) => (
                                    <div key={msg.id}>
                                        {msg.divider ? (
                                            <div className="flex justify-center my-6">
                                                <div className="w-full border-t border-gray-200 relative">
                                                    <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#FDFDFD] px-4 text-xs text-gray-400 font-medium">
                                                        {msg.divider}
                                                    </span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className={`flex w-full ${msg.isBrand ? 'justify-end' : 'justify-start'}`}>
                                                <div className={`flex items-end gap-2 max-w-[70%] ${msg.isBrand ? 'flex-row-reverse' : 'flex-row'}`}>
                                                    
                                                    {/* Avatar */}
                                                    <div className={`w-6 h-6 rounded-full shrink-0 flex items-center justify-center overflow-hidden text-xs font-bold text-white
                                                        ${msg.isBrand ? 'bg-[#0044CC]' : 'bg-gray-200'}
                                                    `}>
                                                        {msg.isBrand ? 'S' : <img src="https://i.pravatar.cc/100?u=4" alt="Creator" className="w-full h-full object-cover" />}
                                                    </div>

                                                    {/* Bubble */}
                                                    <div className="flex flex-col">
                                                        <div className={`px-5 py-3.5 rounded-2xl text-sm leading-relaxed shadow-sm
                                                            ${msg.isBrand 
                                                                ? 'bg-[#0044CC] text-white rounded-tr-sm' 
                                                                : 'bg-white border border-gray-100 text-gray-800 rounded-tl-sm'
                                                            }
                                                        `}>
                                                            {msg.text}
                                                        </div>
                                                        {msg.time && (
                                                            <span className={`text-[10px] text-gray-400 mt-1 ${msg.isBrand ? 'text-right' : 'text-left'}`}>
                                                                {msg.time}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Input Area */}
                            <div className="p-6 bg-white shrink-0">
                                <div className="flex items-center gap-4">
                                    <button className="text-gray-400 hover:text-gray-600 transition-colors">
                                        <HiOutlineEmojiHappy className="text-2xl" />
                                    </button>
                                    <input 
                                        type="text" 
                                        placeholder="Write a message..."
                                        value={messageInput}
                                        onChange={(e) => setMessageInput(e.target.value)}
                                        className="flex-1 bg-transparent text-sm focus:outline-none placeholder-gray-400"
                                    />
                                    <button className="w-10 h-10 bg-[#0044CC] text-white rounded-xl flex items-center justify-center hover:bg-blue-700 transition-colors shadow-md">
                                        <i className="fa-solid fa-paper-plane text-sm"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN: Campaign Status Tracker */}
                        <div className="w-80 border-l border-gray-100 bg-white shrink-0 overflow-y-auto custom-scrollbar p-8">
                            <h2 className="text-xl font-bold text-gray-900 mb-8">Status</h2>
                            
                            <div className="relative border-l border-dashed border-gray-200 ml-4 space-y-8 pb-4">
                                {activeChat.statuses.map((status) => {
                                    const isCompleted = status.status === "completed";
                                    const isCurrent = status.status === "current";
                                    
                                    return (
                                        <div key={status.id} className="relative flex items-center pl-8">
                                            {/* Status Dot/Icon */}
                                            <div className={`absolute -left-3 w-6 h-6 rounded-full flex items-center justify-center bg-white border-2
                                                ${isCompleted ? 'border-[#0044CC] text-[#0044CC]' : ''}
                                                ${isCurrent ? 'border-[#0044CC]' : ''}
                                                ${!isCompleted && !isCurrent ? 'border-gray-300' : ''}
                                            `}>
                                                {isCompleted ? (
                                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                    </svg>
                                                ) : isCurrent ? (
                                                    <div className="w-2.5 h-2.5 bg-[#0044CC] rounded-full"></div>
                                                ) : null}
                                            </div>

                                            {/* Status Label Pill */}
                                            <div className={`w-full px-4 py-2.5 rounded-xl flex justify-between items-center transition-all
                                                ${status.highlighted ? 'bg-[#F4F1FB]' : 'bg-transparent border border-gray-200'}
                                                ${isCurrent ? 'border-[#0044CC]' : ''}
                                            `}>
                                                <span className="text-xs font-bold text-gray-900">{status.label}</span>
                                                {isCompleted && (
                                                    <div className="w-4 h-4 rounded-full border border-green-500 flex items-center justify-center text-green-500">
                                                        <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                        </svg>
                                                    </div>
                                                )}
                                                {isCurrent && (
                                                    <div className="w-4 h-4 rounded-full border border-green-500 flex items-center justify-center text-green-500">
                                                        <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                        </svg>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

const NavItem = ({ to, icon, label, active }) => (
    <Link to={to} className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${active ? 'bg-blue-50 text-[#0044CC]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`}>
        <span className="text-xl">{icon}</span>
        {label}
    </Link>
);

export default BrandMessages;
